
































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class WidgetCoupon extends Vue {
  @Prop({ default: '27' }) readonly width?: string;
  @Prop({ default: '23' }) readonly height?: string;
  @Prop({ default: 'currentColor' }) readonly color?: string;
}
